import { Expose, Type } from "class-transformer";
import { EventListModel } from "@/models/classes/event/event_list";
import { ActivityType } from "@/models/enums/activity_type";

export class ActivityItemModel {
  constructor() {
    this.planId = 0;
    this.id = 0;
    this.name = "";
    this.order = 0;
    this.visitType = undefined;
    this.shopType = undefined;
    this.isOffPlan = false;
    this.isInCallPlan = false;
    this.isEActivity = false;
    this.date = undefined;
    this.isClosed = false;
  }


  @Expose({ name: "customerPlanId" })
  planId: number;

  @Expose({ name: "customerId" })
  id: number;

  @Expose({ name: "customerName" })
  name: string;

  @Expose({ name: "checkInData" })
  checkIn?: string;

  @Expose({ name: "checkOutData" })
  checkOut?: string;

  @Expose({ name: "eActivityDisplayDate" })
  date?: string;

  @Expose({ name: "dateStartEnd" })
  duration?: string;

  @Expose({ name: "orderRank" })
  order: number;

  @Expose({ name: "visitType" })
  visitType?: string;

  @Expose({ name: "shopType" })
  shopType?: string;

  @Expose({ name: "isOffPlan" })
  isOffPlan?: boolean;

  @Expose({ name: "suggestedBy" })
  suggestedBy?: string;

  @Expose({ name: "activityType" })
  activityType?: string;

  @Expose({ name: "event" })
  @Type(() => EventListModel)
  event?: EventListModel;

  isEActivity: boolean;
  isInCallPlan: boolean;
  isClosed: boolean;

  get isChecked() {
    return this.checkIn != null ? true : false;
  }

  get isSuggestedByAI() {
    return this.suggestedBy == "AI";
  }

  get isEvent() {
    return (
      this.activityType == ActivityType.EVENT &&
      this.event?.eventId != null &&
      this.event.eventId > 0
    );
  }
}
